import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  isCompleted: boolean;
};

export const Icon = ({ icon, isCompleted }: Props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    color={isCompleted ? "success.main" : "primary.main"}
    sx={{ "& svg": { fontSize: 40 } }}
  >
    {isCompleted ? <CheckCircleOutlineIcon /> : icon}
  </Box>
);
